import axios from 'axios';
import { decodeToken, getToken } from './TokenUtils';
import { CURRENT_DATE, FIRST_DAY_OF_MONTH } from '../constants';
import { API_URL, ENDPOINTS } from '../constants/api';
import html2canvas from 'html2canvas';

import jsPDF from 'jspdf';
import 'jspdf-autotable';

//Remove fields from Data
export const removeFields = (data, fieldsToRemove) => {
  const filteredData = { ...data }; // Create a shallow copy to avoid mutating the original object

  fieldsToRemove.forEach((field) => {
    if (filteredData.hasOwnProperty(field)) {
      delete filteredData[field];
    }
  });

  return filteredData;
};

export const queryResultsTable = ({ results }) => {
  console.log('result:', results);
  return (
    <div className="container mt-3">
      <h2>Query Results</h2>
    </div>
  );
};

//  Function to remove specific columns (properties)
export const removeColumns = (data, columnsToRemove) => {
  return data.map((item) => {
    const newItem = { ...item };
    columnsToRemove.forEach((col) => delete newItem[col]);
    return newItem;
  });
};

export const apiKey =
  '3f72ef31838a6cf7e082718614350592a56d06a57ba48e1206addf949b1734bd662265d87239cbd582ae3be050606943';

// reusable fetchForm function
export const fetchForm = async ({
  url,
  queryObj = {},
  setLink,
  setInputs,
  setValues,
  setLoading,
  setInitialValues=null,
  isModal = false,
}) => {
  const initialState = {};
  const token = getToken();
  const userId = decodeToken(token, 'id');
  const branchId = decodeToken(token, 'branch_id');
  if (isModal) {
    initialState['clearAfterSubmit'] = true;
  }
  try {
    const response = await axios.get(url, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    });

    const { link, inputs } = response.data;

    if (setLink) setLink(link || []);
    if (setInputs) setInputs(inputs || []);
    console.log("now inputs: ",inputs)
    // loop through inputs
    inputs?.forEach((input) => {
      if (input.type === 'file') {
        initialState[input.name] = null;
      } else if (queryObj.hasOwnProperty(input.name)) {
        initialState[input.name] = queryObj[input.name];
      } else if (
        [
          'dropdown',
          'load-input',
          'load-dropdown',
          'enum-dropdown',
          'group-dropdown',
        ].includes(input.type)
      ) {
        const selectedOption = input?.dynamic_options?.find(
          (option) => option.selected === 'selected'
        );
        if (selectedOption) {
          initialState[input.name] = selectedOption.value;
        } else if (input.value) {
          initialState[input.name] = input.value;
        } else {
          !isModal
            ? (initialState[input.name] = '%')
            : (initialState[input.name] = '');
        }
      } else if (
        input.type === 'date' &&
        input.name === 'from' &&
        input.value === 'first_day_of_month'
      ) {
        initialState[input.name] = FIRST_DAY_OF_MONTH;
      } else if (input.type === 'first_day_of_month') {
        initialState[input.name] = FIRST_DAY_OF_MONTH;
      } else if (
        (input.type === 'date' && ['to', 'today-from'].includes(input.name)) ||
        input.type === 'today-date'
      ) {
        initialState[input.name] = CURRENT_DATE;
      } else if (input.type === 'hidden-user') {
        initialState[input.name] = userId;
      } else if (input.type === 'hidden-branch') {
        initialState[input.name] = branchId;
      } else {
        initialState[input.name] = input.value?.trim?.() || '';
      }
    });

    if (setValues) setValues(initialState);
    if (setInitialValues && isModal) {
      setInitialValues(initialState);
    }
    if (setLoading) setLoading(false);
  } catch (error) {
    console.error('Error fetching form:', error);
    if (setLink) setLink([]);
    if (setInputs) setInputs([]);
    if (setLoading) setLoading(false);
  }
};

export const filterRow = (row) => {
  return Object.keys(row).reduce((acc, key) => {
    const parts = key.split('~');
    if (parts[parts.length - 1] === 'options') return acc;

    if (parts.length >= 2) {
      const secondPart = parts[1]?.trim(); // trim to remove spaces

      // 🚫 skip if secondPart is "only_name"
      if (secondPart && secondPart !== 'only_name') {
        acc[secondPart] = row[key];
      }
    }
    return acc;
  }, {});
};

export const loadDropdown = async (
  value,
  input,
  setLoading,
  setValues,
  setInputs
) => {
  // ✅ Extract all needed values in one place
  console.log('value:', value, 'input:', input);
  const token = getToken();

  const inputId = input?.id;
  const inputName = input?.name;
  const loadInputName = input?.load_input_name;

  // if no load input name stop it
  if (!loadInputName) {
    console.log('returned');
    // notification.error({
    //   message: 'Failed to load, please specify the load_input_name',
    // });
    setLoading(false);
    return;
  }

  try {
    setLoading(true);
    const url = `${API_URL}/${ENDPOINTS.SYS}/load-dropdown/${inputId}/${value}`;
    const response = await axios.get(url, {
      headers: { Authorization: token ? `Bearer ${token}` : '' },
    });

    const results = response.data.results || [];

    if (input.type === 'load-dropdown2') {
      const newOptions = results.map((r) => r.id);
      setInputs((prev) =>
        prev.map((inp) =>
          inp.name === loadInputName
            ? {
                ...inp,
                dynamic_options: inp.dynamic_options.filter((opt) =>
                  newOptions.includes(opt.id)
                ),
              }
            : inp
        )
      );
    } else if (input.type === 'load-input') {
      const val = results.length > 0 ? results[0]?.id : 0;
      setValues((prev) => ({
        ...prev,
        [loadInputName]: val,
      }));
    } else {
      setInputs((prev) =>
        prev.map((inp) =>
          inp.name === loadInputName
            ? { ...inp, dynamic_options: results }
            : inp
        )
      );
    }
  } catch (error) {
    console.error('Error fetching suggestions:', error);
  } finally {
    setLoading(false);
  }
};

export const loadInfo = async (
  response,
  input,
  suggestion,
  setInputs,
  setValues
) => {
  if (!input?.load_info_sql_query) return;
  const token = getToken();
  try {
    const url = `${API_URL}/${ENDPOINTS.SYS}/load-info/${input.id}/${suggestion.id}`;
    const res = await axios.get(url, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    });
    const info = res.data.info;
    // Update the inputs with loadInfo
    setInputs((prevInputs) =>
      prevInputs.map((item) =>
        item.id === input.id ? { ...item, loadInfo: info } : item
      )
    );

    // Update values if load_input_name matches returned info
    setInputs((prevInputs) => {
      const loadInputNames = input.load_input_name
        .split(',')
        .map((s) => s.trim());

      const loadValues = info
        .toString()
        .split(',')
        .map((s) => s.trim());

      if (loadInputNames.length === loadValues.length) {
        setValues((prevValues) => {
          const updatedValues = { ...prevValues };

          loadInputNames.forEach((field, idx) => {
            updatedValues[field] = loadValues[idx];
          });

          return updatedValues;
        });
      } else {
        console.warn(
          '⚠️ Mismatch between input names and values:',
          loadInputNames,
          loadValues
        );
      }

      return prevInputs;
    });
  } catch (err) {
    console.error('Error fetching load info:', err);
  }
};

export const fetchSuggestions = async (
  query,
  inputId,
  token,
  setLoading,
  setSuggestions,
  setResponse
) => {
  if (!query) {
    setSuggestions((prev) => ({ ...prev, [inputId]: [] }));
    return;
  }

  try {
    setLoading(true);

    const url = `${API_URL}/${ENDPOINTS.SYS}/autocomplete-v2/${inputId}?query=${encodeURIComponent(query)}`;
    const response = await axios.get(url, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    });

    setResponse(response.data);
    setSuggestions((prev) => ({
      ...prev,
      [inputId]: response.data.results,
    }));
  } catch (error) {
    console.error('Error fetching suggestions:', error);
  } finally {
    setLoading(false);
  }
};

export const submitRow = async (row, rowIndex, token = null) => {
  console.log('row2:', row);
  const filteredRow = filterRow(row);
  console.log('filteredRow2:', filteredRow);
  const route = filteredRow.api_route.split(':')[0];
  const routeType = filteredRow.api_route.split(':')[1];
  delete filteredRow.api_route;

  let insertUrl = `${API_URL}/${ENDPOINTS.SYS}/create/${route}`;
  const data = new FormData();

  if (routeType && routeType === 'upload') {
    insertUrl = `${API_URL}/${ENDPOINTS.SYS}/create-upload/${route}`;

    // Append all fields (including files) to FormData
    // Object.keys(values2).forEach((key) => {
    //   data.append(key, values2[key]); // Appends both files and text fields dynamically
    // });

    // Append all fields (including files) to FormData
    Object.keys(filteredRow).forEach((key) => {
      const value = filteredRow[key];
      console.log(key, ':', value);
      if (Array.isArray(value)) {
        value.forEach((file) => {
          data.append(key, file); // ✅ No square brackets
        });
      } else {
        data.append(key, value);
      }
    });
  }
  //console.log('url:', insertUrl, 'data:', data);
  try {
    let response;
    if (routeType && routeType === 'upload') {
      response = await axios.post(insertUrl, data, {
        headers: {
          'Content-Type': 'multipart/form-data', // Required for FormData
          Authorization: token ? `Bearer ${token}` : '',
        },
        // onUploadProgress: (progressEvent) => {
        //   const percent = Math.round(
        //     (progressEvent.loaded * 100) / progressEvent.total
        //   );
        //   setProgress(percent);
        // },
      });
    } else {
      response = await axios.post(insertUrl, filteredRow, {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      });
    }
    return {
      success: response.data.success === 1,
      message: response.data.message,
      result: response.data,

      row,
      rowIndex,
    };
  } catch (error) {
    return {
      success: false,
      message: error.message,
      row,
      rowIndex,
    };
  }
};

export const fetchProfile = async (token, userType, setUser) => {
  try {
    // API call to login
    const response = await axios.get(
      `${API_URL}/api/users/profile/${userType}-profile`,
      {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      }
    );

    // console.log(response.data.company);
    setUser(response.data.user[0]);
  } catch (error) {
    // Handle error (e.g., invalid credentials)
    console.log('erro:', error);
    // setError('Company not found');
  }
};

export const getCompany = async (setCompany) => {
  const response = await axios.get(
    `${API_URL}/api/users/get-company/user-login`
  );
  console.log('co:', response.data.company[0]);
  setCompany(response.data.company[0]);
};

export const getBase64FromUrl = async (imageUrl) => {
  const response = await fetch(imageUrl);
  const blob = await response.blob();

  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
};

export function generateColumnsFromData(data) {
  if (!Array.isArray(data) || !data.length) return [];

  return Object.keys(data[0]).map((key) => ({
    key,
    title: key.replace(/_/g, ' ').toUpperCase(),
  }));
}

/**
 * Reusable PDF Export Utility
 */
export async function exportToPDF({
  link,

  title,
  reportHeader = [],
  columns = [],
  data = [],
  selectedColumns = [],
  fieldsToRemove = [],
  removeColumns2 = [],
  token,
}) {
  const userId = decodeToken(token, 'id');
  const companyBanner = decodeToken(token, 'banner');

  const banner = `${API_URL}/${companyBanner}`;

  try {
    const doc = new jsPDF();

    /* ---------------- Banner ---------------- */
    if (banner) {
      const imageBase64 = await getBase64FromUrl(banner);
      const pageWidth = doc.internal.pageSize.getWidth();
      const imgHeight = 40;
      const imgY = 10;

      doc.addImage(imageBase64, 'PNG', 0, imgY, pageWidth, imgHeight);

      doc.setFontSize(16);
      const titleY = imgY + imgHeight + 10;
      const textWidth = doc.getTextWidth(title);
      doc.text(title, (pageWidth - textWidth) / 2, titleY);
    }

    /* ---------------- Header ---------------- */
    let yOffset = 70;
    if (reportHeader.length) {
      doc.setFontSize(12);
      const entries = Object.entries(reportHeader[0]);

      for (let i = 0; i < entries.length; i += 2) {
        doc.text(`${entries[i][0]}: ${entries[i][1]}`, 14, yOffset);

        if (entries[i + 1]) {
          doc.text(`${entries[i + 1][0]}: ${entries[i + 1][1]}`, 110, yOffset);
        }
        yOffset += 7;
      }
    }

    /* ---------------- Columns ---------------- */
    const uncheckedColumns = columns
      .map((c) => c.key)
      .filter((key) => !selectedColumns.includes(key));

    const fieldsToExclude = [...fieldsToRemove, ...uncheckedColumns];

    const printableData = removeColumns2
      ? removeColumns(data, fieldsToExclude)
      : data;

    if (!printableData.length) {
      throw new Error('No data to export');
    }

    const tableColumns = Object.keys(printableData[0]);
    const tableRows = printableData.map((row) =>
      tableColumns.map((key) => row[key])
    );

    /* ---------------- Table ---------------- */
    doc.autoTable({
      startY: yOffset + 10,
      head: [tableColumns],
      body: tableRows,
    });

    doc.save(`${title}.pdf`);

    /* ---------------- Logs ---------------- */
    var insertUrl = `${API_URL}/${ENDPOINTS.SYS}/create/add-print-log`;

    const printLogs = {
      user_id: userId,
      link_id: link.id,
      print_data: JSON.stringify(data),
      header_data: '',
      footer_data: '',
      ip_address: '',
      user_agent: '',
      print_action: 'pdf',
    };
    await axios.post(
      insertUrl,
      {
        ...printLogs,
        print_data: JSON.stringify(printableData),
        print_action: 'pdf',
      },
      {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      }
    );
  } catch (err) {
    console.error('PDF Export Error:', err);
    throw err;
  }
}

/**
 * Export an HTML element to PDF exactly as displayed
 */
export async function exportElementToPDF({
  element,
  fileName = 'document.pdf',
  orientation = 'p', // p = portrait, l = landscape
  scale = 2,
  margin = 10,
}) {
  if (!element) {
    throw new Error('Element not found');
  }

  const canvas = await html2canvas(element, {
    scale,
    useCORS: true,
    backgroundColor: '#ffffff',
  });

  const imgData = canvas.toDataURL('image/png');

  const pdf = new jsPDF({
    orientation,
    unit: 'mm',
    format: 'a4',
  });

  const pageWidth = pdf.internal.pageSize.getWidth() - margin * 2;
  const pageHeight = pdf.internal.pageSize.getHeight() - margin * 2;

  const imgWidth = pageWidth;
  const imgHeight = (canvas.height * imgWidth) / canvas.width;

  let heightLeft = imgHeight;
  let position = margin;

  pdf.addImage(imgData, 'PNG', margin, position, imgWidth, imgHeight);
  heightLeft -= pageHeight;

  while (heightLeft > 0) {
    position = heightLeft - imgHeight + margin;
    pdf.addPage();
    pdf.addImage(imgData, 'PNG', margin, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;
  }

  pdf.save(fileName);
}
